import axios from 'axios'
import { BUSCAR_EMPRESAS_GESTAO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export default function buscarEmpresaGestao (pagina, registrosPorPagina, filtros) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/empresas/${urlFiltros}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_EMPRESAS_GESTAO,
        payload: response

      })
  );
}
